<template>
  <div>

    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
        <v-spacer></v-spacer>
      </v-card-title>

      <v-card-text>
        
          <v-row>
            <v-col cols="12" md="8">
              <v-row dense>
                <v-col cols="12" sm="8" md="8">
                  <v-text-field v-model="dataitem.nombre" label="Nombre *" placeholder="Dell Optiplex 5000"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field v-model="dataitem.codigo" label="Codigo" placeholder="4485541035"></v-text-field>
                </v-col>
                
                <v-col cols="12" sm="4" md="4">
                  <v-text-field v-model="dataitem.preciocompra" label="Precio Compra *" prefix="Q "></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field v-model="dataitem.preciominimo" label="Precio Minimo *" prefix="Q "></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field v-model="dataitem.preciosugerido" label="Precio Sugerido *" prefix="Q "></v-text-field>
                </v-col>
                
                <v-col cols="12">
                  <v-textarea outlined v-model="dataitem.descripcion" label="Descripcion Detallada"
                    placeholder="Caracteristicas: Procesador Intel Core i91522, RAM: 16GB DDR4, 1TB de Almacenamiento, Incluye Mouse y Teclado"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="4">
              <v-row dense>
                <v-col cols="12">
                  <v-checkbox
                    v-model="dataitem.controlstock"
                    :label="dataitem.controlstock?'Control STOCK Activado':'Control STOCK Desactivado'"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete v-model="dataitem.tipo" :items="itemstipo" outlined clearable
                    hide-selected item-text="nombre" item-value="codigo" label="Seleccione Tipo" dense>
                  </v-autocomplete>
                </v-col>
                
                <v-col cols="12">
                  <v-autocomplete v-model="dataitem.idcategoria" :items="getCategoriasActivas" outlined clearable
                    hide-selected item-text="nombre" item-value="idcategoria" label="Seleccione Categoria" dense>
                  </v-autocomplete>
                </v-col>
                
              </v-row>
            </v-col>

          </v-row>

  </v-card-text>
  <slot></slot>
    </v-card>

  </div>
</template>
<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import { mapGetters } from 'vuex'
export default {
    props:['dataitem'],
    name:"FormCrear",
    data(){
        return{
            valid: false,
            dialog: false,
            itemstipo:[{nombre:"Bien",codigo:'B'},{nombre:"Servicio",codigo:'S'}],
            itemscategorias:[],
            articulostock:{
              stockminimo: 1,
              stockactual: 1,
              ubicacion:''
            },
            editedItem: {
                codigo: '',
                nombre: '',
                descripcion: '',
                preciocompra:1,
                preciosugerido:1,
                preciominimo:1,
                tipo:'B',
                controlstock:true,
                idcategoria: 1,
            },
            defaultItem:{
              codigo: '',
              nombre: '',
              descripcion: '',
              preciocompra:1,
              preciosugerido:1,
              preciominimo:1,
              tipo:'B',
              controlstock:true,
              idcategoria: 1,
            },
            

            
        }
    },
    created(){
        this.main();
    },
    computed:{
        ...mapGetters(['getTokenUser','getUrlApi','getCategoriasActivas','getEstablecimientosActivas']),
        formTitle () {
            return this.dataitem.idarticulo === -1 ? 'Nuevo Registro' : 'Editar Registro'
        },
    },
    methods:{
     async main () {
        await this.$store.dispatch('setAllEstablecimientos')  
        await this.$store.dispatch('setAllCategorias') 
        const id = parseInt(this.dataitem.idarticulo)
        if(id){
          this.getItem(id)
        }      
      },
     async getItem(id){
       try {
         const {data} = await axios.get(`${this.getUrlApi}/articulos/${id}`,this.getTokenUser)
          this.editedItem = Object.assign({}, data)
          this.editedItem.idcategoria = data.idcategoria.idcategoria
        } catch (error) {
          console.log(error)
        }
     },
     async postItem(){

        try {
           const { data }=await axios.post(`${this.getUrlApi}/articulos`,this.editedItem,this.getTokenUser)
    
           this.$emit('setdata',data)
          
        } catch (error) {
            console.log(error)
            Swal.fire('Error al crear registro','','error') 
        }
        
      },
      async putItem(){

        try {
          const { data } = await axios.put(`${this.getUrlApi}/articulos/${this.dataitem.idarticulo}`,this.editedItem,this.getTokenUser)


           this.$emit('setdata',data)
        } catch (error) {
            console.log(error)
            Swal.fire('Error al actualizar registro','','error') 
        }
        
      },
      async save () {
        delete this.dataitem.idcategoria;
       this.editedItem = Object.assign(this.defaultItem,this.dataitem);

        if (this.dataitem.idarticulo > -1) {       
         await this.putItem()
        } else {
         await this.postItem()
        }
        this.close()
      },
      close () {
        this.$nextTick(() => {
          
          this.editedItem = Object.assign({}, this.defaultItem)
          this.existencias = Object.assign({}, this.clearExistencias)
         
        })
      },
    }
}
</script>